import './index.scss';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import React from 'react';
import _ from 'lodash';
import { useNotificationToaster, useQueryToasterNotifications } from './api';

const FIVE_SECONDS = 5000;

const render = (element, data) => (_.isFunction(element) ? element(data) : element);

const toastBackground = (toast) => (toast?.bg || _.get({
  danger: 'danger100',
  error: 'danger100',
  warning: 'warning100',
  info: 'info100',
  success: 'success100',
}, _.toLower(toast?.category)) || 'gray100');

const toastAutoHide = (toast) => (_.has(toast, 'autohide') ? !!(toast?.autohide) : false);
const toastDelay = (toast) => (toast?.delay || FIVE_SECONDS);

const SingleToast = ({ toast }) => {
  const { dismiss } = useNotificationToaster();
  const onClose = React.useCallback(() => dismiss(toast), [dismiss, toast]);
  const bg = toastBackground(toast);
  const autohide = toastAutoHide(toast);
  const delay = toastDelay(toast);
  return (
    <Toast
      {...{
        bg, autohide, delay, onClose,
      }}
      show
    >
      <Toast.Header>
        {render(toast?.title, { toast })}
      </Toast.Header>
      <Toast.Body>
        {render(toast?.details, { toast })}
      </Toast.Body>
    </Toast>
  );
};

const Toasts = () => {
  const query = useQueryToasterNotifications();
  return (
    <>
      {_.map(query?.data?.toasts, (toast) => (<SingleToast key={toast?.id} toast={toast} />))}
    </>
  );
};

export const NotificationsToaster = () => (
  <ToastContainer position="top-end" className="rax-toast-container">
    <Toasts />
  </ToastContainer>
);
